/* ============================================================
   AMERICAN HEX — Theme JS
   ============================================================ */

document.addEventListener('DOMContentLoaded', () => {

  // ---- Cart count badge ----
  function updateCartCount() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        document.querySelectorAll('.cart-count').forEach(el => {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
      });
  }
  updateCartCount();

  // ---- Product gallery thumbnails ----
  const thumbs = document.querySelectorAll('.product-gallery__thumb');
  const mainImg = document.querySelector('.product-gallery__main img');
  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      thumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      if (mainImg) mainImg.src = thumb.querySelector('img').src.replace('_80x', '_800x');
    });
  });
  if (thumbs.length > 0) thumbs[0].classList.add('active');

  // ---- Size selection ----
  document.querySelectorAll('.size-btn:not(.sold-out)').forEach(btn => {
    btn.addEventListener('click', () => {
      const group = btn.closest('.size-grid');
      group.querySelectorAll('.size-btn').forEach(b => b.classList.remove('selected'));
      btn.classList.add('selected');
      // Update hidden variant input if present
      const variantId = btn.dataset.variantId;
      const input = document.getElementById('variant-id');
      if (input && variantId) input.value = variantId;
    });
  });

  // ---- Add to cart ----
  const addToCartForm = document.getElementById('add-to-cart-form');
  const addToCartBtn = document.getElementById('add-to-cart-btn');
  if (addToCartForm && addToCartBtn) {
    addToCartForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const variantId = document.getElementById('variant-id')?.value;
      if (!variantId) {
        addToCartBtn.textContent = 'Select a size';
        return;
      }
      addToCartBtn.textContent = 'Adding...';
      addToCartBtn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(r => r.json())
      .then(() => {
        addToCartBtn.textContent = 'Added ✓';
        updateCartCount();
        setTimeout(() => {
          addToCartBtn.textContent = 'Add to Cart';
          addToCartBtn.disabled = false;
        }, 2000);
      })
      .catch(() => {
        addToCartBtn.textContent = 'Error — try again';
        addToCartBtn.disabled = false;
      });
    });
  }

  // ---- Announcement bar dismiss ----
  const dismissBtn = document.getElementById('announcement-dismiss');
  if (dismissBtn) {
    dismissBtn.addEventListener('click', () => {
      const bar = document.getElementById('announcement-bar');
      if (bar) bar.style.display = 'none';
    });
  }

  // ---- Smart sticky header — hide on scroll down, glide in on scroll up ----
  const header = document.querySelector('.site-header');
  if (header) {
    let lastY = 0;
    let ticking = false;
    const threshold = 80;

    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          const currentY = window.scrollY;
          if (currentY < threshold) {
            header.classList.remove('header--hidden');
          } else if (currentY > lastY) {
            header.classList.add('header--hidden');
          } else {
            header.classList.remove('header--hidden');
          }
          lastY = currentY;
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  // ---- Mobile menu toggle ----
  const menuToggle = document.getElementById('menu-toggle');
  const mobileMenu = document.getElementById('mobile-menu');
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      const open = mobileMenu.style.display === 'block';
      mobileMenu.style.display = open ? 'none' : 'block';
      menuToggle.setAttribute('aria-expanded', !open);
    });
  }

});
